import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-two',
  templateUrl: './loader-two.component.html',
  styleUrls: ['./loader-two.component.scss']
})
export class LoaderTwoComponent {
  pageType: string = 'fahes';

  constructor(){
    // if (typeof window !== 'undefined') {
    //   const pathArray = window.location.pathname.split("/").filter(Boolean); // remove empty strings
    //   if (pathArray.some(segment => segment === "fahes")) this.pageType = "fahes";
    // }
  }

}
